module.exports = __webpack_public_path__ + "static/media/mst_log.f321a91b.png";